import axiosConfig from "../../../utils/axiosConfig";

let baseUrl = "pages/sales_revenue/past_dues_performance_chart";

export const api = {
  getValues(params) {
    return axiosConfig.get(`${baseUrl}`, params);
  }
};
